import styled from "styled-components";
import { FullHeightWrapper } from "components/PluginSelectionModal/styles";

export const FullHeightWrapperWithBackGroundColor = styled(FullHeightWrapper)`
  background-color: ${(props) => props.theme['modal.input.bg.color'] || props.theme['color.background']};
  padding-left:105px;
`;